import * as API from "axios/axios";

export const ProductSNService = {
  uploadImage: (data) => API.post("/api/product_sns/image", data),
};
